import { render, staticRenderFns } from "./Highscores.vue?vue&type=template&id=024d0eb6&scoped=true&"
import script from "./Highscores.vue?vue&type=script&lang=js&"
export * from "./Highscores.vue?vue&type=script&lang=js&"
import style0 from "./Highscores.vue?vue&type=style&index=0&id=024d0eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d0eb6",
  null
  
)

export default component.exports